// Shared across every proposal: the listing process steps.
// Edit here once; every client's page picks it up.

export const process = [
  { title: "Hire me", text: "We confirm your goals and agree on the plan." },
  { title: "Pre-listing process", text: "Pre-inspect the home and handle priority repairs or updates." },
  { title: "Marketing prep week", text: "Staging, photography and the marketing materials." },
  { title: "Marketing launch week", text: "Publish the listing, launch promotion and begin showings." },
  {
    title: "Ongoing marketing and regular communication",
    text: "I follow up with buyers, report results and adjust.",
  },
];
